import { STAGE_DEFS, type StageKey } from "../../utils/transactionStage";
import type { Theme } from "@mui/material";

export type DrillState =
  | { level: "year" }
  | { level: "month"; year: number }
  | { level: "day"; year: number; month: number };

/** Shape returned by api.dashboardCharts.getStageTimeline — shared by the bar
 * chart and the unmatched donut so both read the same query result. */
export type StageBucket = {
  period: string;
  label: string;
  counts: Record<StageKey, number>;
  total: number;
};
export type TimelineResult = {
  granularity: string;
  parent: { year?: number; month?: number };
  buckets: StageBucket[];
  truncated: boolean;
};

export function argsForDrill(d: DrillState): {
  granularity: "year" | "month" | "day";
  year?: number;
  month?: number;
} {
  if (d.level === "year") return { granularity: "year" };
  if (d.level === "month") return { granularity: "month", year: d.year };
  return { granularity: "day", year: d.year, month: d.month };
}

/** A column click drills DOWN, except at day level where it drills UP to the
 * month (the inverse path the user specified). `period` is the bucket key
 * ("2026" | "2026-03" | "2026-03-12"). */
export function drillDownFromColumn(d: DrillState, period: string): DrillState {
  if (d.level === "year") return { level: "month", year: Number(period) };
  if (d.level === "month") {
    const [y, m] = period.split("-");
    return { level: "day", year: Number(y), month: Number(m) };
  }
  return { level: "month", year: d.year };
}

export function colorForStage(key: StageKey, palette: Theme["palette"]): string {
  const c = STAGE_DEFS[key].color;
  if (c === "default") return palette.grey[500];
  return palette[c].main;
}
